export enum FormType {
  Create = 1,
  Update = 2,
}
